import React from "react";
import { DoorIconProps } from "./DeKaap";
import classNames from "classnames";

export const DeMeent: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2h23.273v12.318H2V2ZM0 15.318V0h27.273v60H0V15.318Zm2 30V58h23.273V45.318H2Zm23.273-1H2v-14h23.273v14Zm0-29v14H2v-14h23.273Z"
        fill="#9493A3"
      />
    </svg>
  );
};
